export default __webpack_public_path__ + "static/media/logo.e193db18.svg";